// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "0d2fedffddcd";
export const BUILD_VERSION_NUMBER = 50;
